<template>
    <router-link
        :to="{ 
            name: 'reservations',
            query: {
                attention:1
            }
        }"
        :href="href"
        @click="navigate"
        custom
        v-slot="{ href, navigate }"
    >
        <a class="nav-link" :href="href" @click="navigate">
            <i class="fa fa-bell-o" aria-hidden="true"></i>
            <span v-if="unreadMessagesCount" class="badge bg-warning navbar-badge">{{ unreadMessagesCount }}</span>
        </a>
    </router-link>
</template>

<script>
import { vOnClickOutside } from '@vueuse/components'
import apiService from 'services/api.service'

export default {
    data() {
        return {
            showMessage: null,
            isWidgetOpen: false,
            unreadMessagesCount: 0,
            messages: [
                { text: 'Пример сообщения 1', read: false },
                { text: 'Пример сообщения 2', read: true },
                { text: 'Пример сообщения 3', read: false }
            ],
            selectedMessageIndex: null
        };
    },
    directives: {
        onClickOutside: vOnClickOutside
    },
    methods: {
        getUnreadCount() {
            apiService.getFrApi({
                url: 'reservations/getNewReservationCount',
                method: 'get',
                params: {},
                locale: this.locale
            }).then(response => {
                if (response.data.success) {
                    this.unreadMessagesCount = response.data.data;
                }
            })
        },
        toggleWidget() {
            this.isWidgetOpen = !this.isWidgetOpen;
        },
        closeWidget() {
            this.isWidgetOpen = false;
            this.selectedMessageIndex = null;
        },
        openMessage(message) {
            message.read = true;
            this.showMessage = message;
            this.updateUnreadMessagesCount();
        },
        updateUnreadMessagesCount() {
            this.unreadMessagesCount = this.messages.filter(message => !message.read).length;
        }
    },
    mounted(){
        this.getUnreadCount();
    }
};
</script>

<style scoped>
.unread {
    font-weight: bold;
}

.dropdown-menu {
    right: 20px;
    font-size: var(--bs-nav-link-font-size);
}
.navbar-badge{
    right: 0;
}
</style>
